import React, { useContext, useEffect, useState } from 'react';
import AppContext from '../Context/AppContext';
import MainLayout from '../layout/MainLayout';
import CenterLayout from '../layout/CenterLayout';
import SideLeft from '../layout/SideLeft';
import ServerStream from '../components/ServerStream';
import { get } from '../utils/fetcher';
import StorageListItem from '../components/StorageListItem';
import VideoLocationLoad from '../components/VideoLocationLoad';
import { Folder, Server } from 'lucide-react';
import ProcessingVideo from '../components/ProcessingVideo';

const ListDomain = () => {

    const [groupDomaines, setGroupDomaines] = useState(null);
    const init = async () => {
        const result = await get('/domaines/get');

    }
    useEffect(() => {

    }, [])
    return (
        <MainLayout>
            <CenterLayout>
                <p className='cw fs1 fr'>Liste nom de domaine</p>
                <div className='tab-ldomain'>

                </div>
            </CenterLayout>
            <SideLeft>
                <ServerStream />
            </SideLeft>
        </MainLayout>
    );
};

export default ListDomain;